import _ from 'lodash'

class Components {
  constructor() {
    this.allComponents = {}
  }

  saveComponent(key, component) {
    this.allComponents[key] = component
  }

  getComponents() {
    return this.allComponents
  }

  getComponent(key) {
    return this.allComponents[key]
  }
}

var components = new Components()
export default components



// WEBPACK FOOTER //
// ./src/utils/components.js